import React from "react";

const FeaturedProducts = () => {
  const scrollToSection = (section_title) => {
    var ele = document.getElementById(section_title);
    window.scrollTo(ele.offsetLeft, ele.offsetTop);
  };
  return (
    <section className="section featured" id="featured">
      <div className="featured__container container">
        <div className="title">
          <h1 className="primary__title">Featured Products</h1>
        </div>

        <div className="featured__center">
          <div className="product">
            <div className="img__container">
              <img src="./images/pic5.png" alt="" />
            </div>
            <div className="product__bottom">
              <div className="rating">
                <span>
                  <svg>
                    <use xlinkHref="./images/sprite.svg#icon-star-full"></use>
                  </svg>
                </span>
                <span>
                  <svg>
                    <use xlinkHref="./images/sprite.svg#icon-star-full"></use>
                  </svg>
                </span>
                <span>
                  <svg>
                    <use xlinkHref="./images/sprite.svg#icon-star-full"></use>
                  </svg>
                </span>
                <span>
                  <svg>
                    <use xlinkHref="./images/sprite.svg#icon-star-full"></use>
                  </svg>
                </span>
                <span>
                  <svg>
                    <use xlinkHref="./images/sprite.svg#icon-star-empty"></use>
                  </svg>
                </span>
              </div>
              <h3>Polar Skate Co Devil T Shirt</h3>
              <span onClick={() => scrollToSection("new__arrival")}>
                Add To Cart
              </span>
            </div>
          </div>
          <div className="product">
            <div className="img__container">
              <img src="./images/pic4.png" alt="" />
            </div>
            <div className="product__bottom">
              <div className="rating">
                <span>
                  <svg>
                    <use xlinkHref="./images/sprite.svg#icon-star-full"></use>
                  </svg>
                </span>
                <span>
                  <svg>
                    <use xlinkHref="./images/sprite.svg#icon-star-full"></use>
                  </svg>
                </span>
                <span>
                  <svg>
                    <use xlinkHref="./images/sprite.svg#icon-star-full"></use>
                  </svg>
                </span>
                <span>
                  <svg>
                    <use xlinkHref="./images/sprite.svg#icon-star-full"></use>
                  </svg>
                </span>
                <span>
                  <svg>
                    <use xlinkHref="./images/sprite.svg#icon-star-empty"></use>
                  </svg>
                </span>
              </div>
              <h3>Polar Skate Co Devil T Shirt</h3>
              <span onClick={() => scrollToSection("new__arrival")}>
                Add To Cart
              </span>
            </div>
          </div>
          <div className="product">
            <div className="img__container">
              <img src="./images/pic3.png" alt="" />
            </div>
            <div className="product__bottom">
              <div className="rating">
                <span>
                  <svg>
                    <use xlinkHref="./images/sprite.svg#icon-star-full"></use>
                  </svg>
                </span>
                <span>
                  <svg>
                    <use xlinkHref="./images/sprite.svg#icon-star-full"></use>
                  </svg>
                </span>
                <span>
                  <svg>
                    <use xlinkHref="./images/sprite.svg#icon-star-full"></use>
                  </svg>
                </span>
                <span>
                  <svg>
                    <use xlinkHref="./images/sprite.svg#icon-star-full"></use>
                  </svg>
                </span>
                <span>
                  <svg>
                    <use xlinkHref="./images/sprite.svg#icon-star-empty"></use>
                  </svg>
                </span>
              </div>
              <h3>Polar Skate Co Devil T Shirt</h3>
              <span onClick={() => scrollToSection("new__arrival")}>
                Add To Cart
              </span>
            </div>
          </div>
          <div className="product">
            <div className="img__container">
              <img src="./images/pic2.png" alt="" />
            </div>
            <div className="product__bottom">
              <div className="rating">
                <span>
                  <svg>
                    <use xlinkHref="./images/sprite.svg#icon-star-full"></use>
                  </svg>
                </span>
                <span>
                  <svg>
                    <use xlinkHref="./images/sprite.svg#icon-star-full"></use>
                  </svg>
                </span>
                <span>
                  <svg>
                    <use xlinkHref="./images/sprite.svg#icon-star-full"></use>
                  </svg>
                </span>
                <span>
                  <svg>
                    <use xlinkHref="./images/sprite.svg#icon-star-full"></use>
                  </svg>
                </span>
                <span>
                  <svg>
                    <use xlinkHref="./images/sprite.svg#icon-star-empty"></use>
                  </svg>
                </span>
              </div>
              <h3>Polar Skate Co Devil T Shirt</h3>
              <span onClick={() => scrollToSection("new__arrival")}>
                Add To Cart
              </span>
            </div>
          </div>
          <div className="product">
            <div className="img__container">
              <img src="./images/pic1.png" alt="" />
            </div>
            <div className="product__bottom">
              <div className="rating">
                <span>
                  <svg>
                    <use xlinkHref="./images/sprite.svg#icon-star-full"></use>
                  </svg>
                </span>
                <span>
                  <svg>
                    <use xlinkHref="./images/sprite.svg#icon-star-full"></use>
                  </svg>
                </span>
                <span>
                  <svg>
                    <use xlinkHref="./images/sprite.svg#icon-star-full"></use>
                  </svg>
                </span>
                <span>
                  <svg>
                    <use xlinkHref="./images/sprite.svg#icon-star-full"></use>
                  </svg>
                </span>
                <span>
                  <svg>
                    <use xlinkHref="./images/sprite.svg#icon-star-empty"></use>
                  </svg>
                </span>
              </div>
              <h3>Polar Skate Co Devil T Shirt</h3>
              <span onClick={() => scrollToSection("new__arrival")}>
                Add To Cart
              </span>
            </div>
          </div>
          <div className="product">
            <div className="img__container">
              <img src="./images/pic10.png" alt="" />
            </div>
            <div className="product__bottom">
              <div className="rating">
                <span>
                  <svg>
                    <use xlinkHref="./images/sprite.svg#icon-star-full"></use>
                  </svg>
                </span>
                <span>
                  <svg>
                    <use xlinkHref="./images/sprite.svg#icon-star-full"></use>
                  </svg>
                </span>
                <span>
                  <svg>
                    <use xlinkHref="./images/sprite.svg#icon-star-full"></use>
                  </svg>
                </span>
                <span>
                  <svg>
                    <use xlinkHref="./images/sprite.svg#icon-star-full"></use>
                  </svg>
                </span>
                <span>
                  <svg>
                    <use xlinkHref="./images/sprite.svg#icon-star-empty"></use>
                  </svg>
                </span>
              </div>
              <h3>Polar Skate Co Devil T Shirt</h3>
              <span onClick={() => scrollToSection("new__arrival")}>
                Add To Cart
              </span>
            </div>
          </div>
          <div className="product">
            <div className="img__container">
              <img src="./images/pic9.png" alt="" />
            </div>
            <div className="product__bottom">
              <div className="rating">
                <span>
                  <svg>
                    <use xlinkHref="./images/sprite.svg#icon-star-full"></use>
                  </svg>
                </span>
                <span>
                  <svg>
                    <use xlinkHref="./images/sprite.svg#icon-star-full"></use>
                  </svg>
                </span>
                <span>
                  <svg>
                    <use xlinkHref="./images/sprite.svg#icon-star-full"></use>
                  </svg>
                </span>
                <span>
                  <svg>
                    <use xlinkHref="./images/sprite.svg#icon-star-full"></use>
                  </svg>
                </span>
                <span>
                  <svg>
                    <use xlinkHref="./images/sprite.svg#icon-star-empty"></use>
                  </svg>
                </span>
              </div>
              <h3>Polar Skate Co Devil T Shirt</h3>
              <span onClick={() => scrollToSection("new__arrival")}>
                Add To Cart
              </span>
            </div>
          </div>
          <div className="product">
            <div className="img__container">
              <img src="./images/pic8.png" alt="" />
            </div>
            <div className="product__bottom">
              <div className="rating">
                <span>
                  <svg>
                    <use xlinkHref="./images/sprite.svg#icon-star-full"></use>
                  </svg>
                </span>
                <span>
                  <svg>
                    <use xlinkHref="./images/sprite.svg#icon-star-full"></use>
                  </svg>
                </span>
                <span>
                  <svg>
                    <use xlinkHref="./images/sprite.svg#icon-star-full"></use>
                  </svg>
                </span>
                <span>
                  <svg>
                    <use xlinkHref="./images/sprite.svg#icon-star-full"></use>
                  </svg>
                </span>
                <span>
                  <svg>
                    <use xlinkHref="./images/sprite.svg#icon-star-empty"></use>
                  </svg>
                </span>
              </div>
              <h3>Polar Skate Co Devil T Shirt</h3>
              <span onClick={() => scrollToSection("new__arrival")}>
                Add To Cart
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturedProducts;
